import type { Bank } from "@/apis/gql/types";
import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";

export interface BankQueryParams {
  ids?: string[];
  iban?: string;
  nameSubstring?: string;
}

export const useGetAllBanks = (params?: BankQueryParams) => {
  const { data, error, loading, refetch } = useQuery<{ searchBanks: Bank[] }>(
    BANKS_QUERY,
    {
      variables: { queryParams: params },
      fetchPolicy: "network-only",
      skip: !params?.nameSubstring,
    },
  );

  return {
    banks: data?.searchBanks ?? [],
    error,
    loading,
    refetch,
  };
};

export const BANKS_QUERY = gql`
  query GetBanks($queryParams: BankQueryParams) {
    searchBanks(queryParams: $queryParams) {
      id
      name
      bic
      blz
      location
      city
      isTestBank
      popularity
      isBeta
      logo {
        url
      }
      icon {
        url
      }
      bankGroup {
        name
        icon {
          url
        }
        logo {
          url
        }
      }
      shouldAddFints
      interfaces {
        bankingInterface
        health
        isAisSupported
        isPisSupported
        aisCapabilities {
          standingOrdersDownload
          pendingTransactionsDownload
        }
        paymentCapabilities {
          sepaMoneyTransfer
          sepaInstantMoneyTransfer
          sepaCollectiveMoneyTransfer
        }
      }
    }
  }
`;
